import { StyleSheet } from 'react-native';
import theme from '../../common/theme';

export const styles = StyleSheet.create({
  content: {
    width: 700,
    padding: 60,
    alignItems: 'center',
    borderRadius: theme.radius.l,
    backgroundColor: theme.palette.white,
    ...theme.shadow.strong,
  },
  title: {
    flex: 1,
    fontSize: 18,
    lineHeight: 26,
    textAlign: 'center',
    fontFamily: theme.fonts.semibold,
    color: theme.palette.mono800,
  },
  btnBack: {
    position: 'absolute',
    left: 20,
    top: 20,
  },
  qrContainer: {
    width: 180,
    height: 180,
    marginTop: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  btnRefresh: {
    position: 'absolute',
    right: -54,
  },
  codeContainer: {
    width: 180,
    padding: 10,
    marginTop: 20,
    borderRadius: theme.radius.s,
    backgroundColor: theme.palette.mono100,
  },
  code: {
    fontSize: 22,
    lineHeight: 38,
    letterSpacing: 1,
    textAlign: 'center',
    fontFamily: theme.fonts.bold,
    color: theme.palette.mono800,
  },
  footnote: {
    fontSize: 14,
    lineHeight: 26,
    textAlign: 'center',
    marginTop: 40,
    maxWidth: 500,
    color: theme.palette.mono600,
    fontFamily: theme.fonts.regular,
  },
});
